export default "\r\n<div style=\"min-height:640px;width:100%\" class=\"container\">\r\n  <router-outlet></router-outlet>\r\n</div>";